import PageRecord from "models/view-models/page-record";
import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface ClonePagePathParams {}

export interface ClonePageBodyParams {
    name: string;
    notebookId: number;
    sourcePageId: number;
}

const baseEndpoint = "pages/copy";
const resourceType = PageRecord;

const CopyPageService = {
    clone: ServiceFactory.createFromPostParams<PageRecord, ClonePageBodyParams>(
        resourceType,
        baseEndpoint
    ),

    useClone: ServiceHookFactory.useCreateFromPostParams<
        PageRecord,
        ClonePageBodyParams
    >(resourceType, baseEndpoint),
};

export default CopyPageService;
